import React from "react";

import PropTypes from "prop-types";
import { MOBILE_MAX_WIDTH } from "utils/constants";
import useWindowDimensions from "utils/hooks/useWindowDimensions";

const ViewControl = ({ children, xs, sm }) => {
  const { width } = useWindowDimensions();

  const render = () => {
    const child = { component: null };
    if (width < MOBILE_MAX_WIDTH && xs) {
      child.component = children;
    }
    if (width > MOBILE_MAX_WIDTH && sm) {
      child.component = children;
    }
    return child;
  };

  return <div>{render().component}</div>;
};

ViewControl.propTypes = {
  children: PropTypes.node.isRequired,
  xs: PropTypes.number.isRequired,
  sm: PropTypes.number.isRequired,
};

export default ViewControl;
